import * as z from 'zod/mini';

import { createStorageKeySchema } from '../../../services/storage';

/**
 * The schema to track the expiration time of the project settings.
 */
export const projectSettingsExpirationStorageKeySchema = createStorageKeySchema(
  {
    key: 'projectSettingsExpiration',
    schema: z.number(),
  }
);
